import api from "@/api";

export const educarMaxiaService = {
  
  async checkGrupoEducar(user = null) {
    try {      
      const result = {
        is_grupo_educar: user.escola === "Escola Integração Evoluir",
        demo: user.demo,
        id_escola: user.id_escola
      };
      
      return result;
    } catch (error) {
      console.error(`Erro ao verificar o grupo Educar: ${error.message}`);
      return {
        is_grupo_educar: false,
        demo: 0,
        id_escola: null
      };
    }
  },

  async fetchIntegracaoEducarMaxia() {
    try {
      const API_URL = api.defaults.baseURL;
      const token = localStorage.getItem('token');
      
      const response = await fetch(`${API_URL}/educar-maxia/avaliacoes/redirecionar`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        console.warn(`Erro na API Educar Maxia: ${response.status} ${response.statusText}`);
        return { 
          success: false, 
          message: "Entre em contato com o gestor da escola para verificar a configuração." 
        };
      }

      const data = await response.json();
      
      if (!data?.url) {
        console.warn("URL de redirecionamento não encontrada na resposta da API Educar Maxia");
        return { 
          success: false, 
          message: "URL de redirecionamento não disponível" 
        };
      }

      return { 
        success: true, 
        url: data.url 
      };
    } catch (error) {
      console.error("Erro ao acessar a API Educar Maxia:", error);
      return { 
        success: false, 
        message: "Entre em contato com o gestor da escola para verificar a configuração." 
      };
    }
  },

  shouldShowMaxiaOption(grupoEducarInfo) {
    return (
      grupoEducarInfo?.is_grupo_educar === true &&
      grupoEducarInfo?.demo === 1 &&
      grupoEducarInfo?.id_escola === 789 || grupoEducarInfo?.id_escola === 804
    );
  },

  redirectToMaxia(url) {
    if (url) {
      window.open(url, '_blank');
    }
  }
};

export default educarMaxiaService; 